// src/services/config.js
// ─────────────────────────────────────────────
// Central API configuration for all services.
// Change base URLs and keys here — one place.
// ─────────────────────────────────────────────

/**
 * Base URL for the AfriClimate backend API.
 * In production set REACT_APP_API_URL (injected at Docker build time).
 * Falls back to localhost:5000 for local development.
 */
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

/**
 * AfriClimate Auth API — user management, roles, OTP verification.
 */
export const AUTH = {
  BASE_URL: process.env.REACT_APP_AUTH_URL || `${API_BASE_URL}/auth`,
  TIMEOUT_MS: 10000,
};

/** AfriClimate sensor data API — device readings, gateways, analytics. */
export const AFRICLIMATE_API = {
  BASE_URL: process.env.NODE_ENV === 'development'
    ? '/api/v1'
    : 'https://api.wirelessplanet.co.ke/api/v1',
  /** Client API key (read-only access) */
  CLIENT_KEY: 'a19a464df82de32f4c238b02060f1c2d8ae8ae968d3e2401142fce4882ff1d54',
  /** Webhook API key (write access — only needed server-side) */
  WEBHOOK_KEY: '950839eb7eb695c5ab31df13d0a70a5995c4035983426eb0c2c43a09f1538e32',
  TIMEOUT_MS: 10000,
};

/** AfriClimate API default request headers */
export const apiHeaders = {
  'Content-Type': 'application/json',
  'X-API-Key': AFRICLIMATE_API.CLIENT_KEY,
};

// Backward-compat aliases — will be removed in a future cleanup
export const TTN = AFRICLIMATE_API;
export const ttnHeaders = apiHeaders;

/** Generic fetch error handler — throws with readable message */
export const handleResponse = async (res) => {
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `HTTP ${res.status} ${res.statusText}`);
  }
  return res.json();
};

/** Fetch with timeout */
export const fetchWithTimeout = (promise, ms = 10000) =>
  Promise.race([
    promise,
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error('Request timed out')), ms)
    ),
  ]);
